<template>
  <div>
    <div class="wizard-header">
      <h3 class="wizard-title">{{ wizardTitle }}</h3>
      <p class="category">{{ wizardDescription }}</p>
    </div>

    <insurers></insurers>
    <div class="row mx-0 px-0">
      <div
        class="row chat m-0"
        :class="showSummarySidebar ? 'col-lg-9 col-12' : 'col-12'"
      >
        <div v-show="showSummaryChat" class="row w-100 mx-auto bg-white">
          <summary-chat
            :data="fields"
            :messages="messages"
            v-on:chatQueryCompleted="chatQueryCompleted"
            windowHeight="windowHeight"
            windowWidth="windowWidth"
          ></summary-chat>
        </div>

        <div v-show="showFinalQuotePage" class="row w-100 mx-auto bg-white">
          <final-screen-quote
            :data="fields"
            :messages="messages"
            :windowHeight="windowHeight"
          ></final-screen-quote>
        </div>

        <error-message></error-message>
        <div
          class="col-md-12 col-sm-12 chat-area-parent"
          v-show="
            !showSummaryChat &&
            !showFinalMessage &&
            !showSummaryForm &&
            !showFinalQuotePage
          "
        >
          <div
            class="chat-area custom-scroll py-0 relative"
            id="chatDiv"
            ref="chatDiv"
            :style="
              windowWidth <= 768
                ? { height: windowHeight - 250 + 'px !important' }
                : { height: windowHeight - 420 + 'px !important' }
            "
          >
            <div v-for="(message, index) in messages" :key="index">
              <system-message
                :ref="'message_' + index"
                :message="message.content"
                :is_alert="
                  message.questions !== undefined &&
                  message.questions !== null &&
                  message.questions.data !== undefined &&
                  message.questions.data.alert !== undefined
                    ? message.questions.data.alert
                    : false
                "
                v-if="message.type == 'system'"
                :type_val="fields.chat_type"
                :index="index"
                :messageInstance="message"
                @updateMessage="updateMessage"
                @scrollToBottom="scrollToBottom"
                :show_avatar="
                  index - 1 >= 0 && messages[index - 1].type == 'system'
                    ? false
                    : true
                "
              ></system-message>
              <user-message
                :ref="'message_' + index"
                :message="
                  message.content.data !== undefined
                    ? message.question !== undefined &&
                      message.question.data !== undefined &&
                      message.question.data.selector !== undefined
                      ? message.content.data[message.question.data.selector]
                      : message.content.data
                    : message.content
                "
                :data="message.content"
                v-if="message.type == 'user'"
              ></user-message>
            </div>

            <div
              class="message chat-message animate slideInUp delay-3s row mx-1"
              v-show="showLoader"
              ref="chatLoader"
            >
              <div class="">
                <img
                  :src="chatImageUrl"
                  alt="Chatbot | PLI"
                  width="100%"
                  height="auto"
                  class="img-circle avatar"
                />
              </div>

              <div class="flex-grow-1 pl-2">
                <div class="message-box">
                  <img :src="chatImageGifUrl" width="30px" />
                </div>
              </div>
            </div>

            <div ref="chatEndPoint" style="height: 1px">&nbsp;</div>
          </div>
          <chat-responses
            v-if="responses.length > 0 && !calculating"
            :data="responses"
            @selectedUserResponse="responseSelected"
            @questionAnswered="questionAnswered"
            @coverSelection="coverSelection"
            ref="inputRef"
          ></chat-responses>
          <div
            v-if="responses.length == 0"
            style="width: 100%; height: 80px; background-color: #fff"
          ></div>
        </div>
        <div
          class="col-12 mt-5 chat-list-area-parent"
          v-show="showFinalMessage"
        >
          <final-screen-chat v-on:redoChat="restartChat"> </final-screen-chat>
        </div>
      </div>
      <div
        class="row col-lg-3 col-12 m-0 px-0"
        v-show="showSummarySidebar && !showFinalQuotePage"
      >
        <summary-section
          :summaryShown="showSummaryForm"
          :messages="messages"
          v-on:scrollTo="scrollTo"
          v-on:switchToForm="switchToForm"
          v-on:showDetails="showDetails"
          :windowHeight="windowHeight"
          :windowWidth="windowWidth"
          :showLoader="showLoader"
          :fields="fields"
          :formComplete="formComplete"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 *  Import dependencies & event bus
 */
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import store from "../../store";
import { isEmpty, find, pick, get, omit, isNil, includes } from "lodash";
import * as appConfigs from "../../configs";
import axios from "axios";
import Cookies from "js-cookie";
import swal from "sweetalert";

import {
  generateErrorMessage,
  formValidate,
  requireHeatWorkPercentage,
} from "../../helpers";

/**
 * Import local components
 */

import SystemMessage from "./SystemMessage.vue";
import UserMessage from "./UserMessage.vue";
import ChatResponses from "./ChatResponses.vue";
import SummaryChat from "./SummaryChat.vue";
import FinalScreenChat from "./FinalScreenChat.vue";
import SummarySection from "./SummarySection.vue";
import FinalScreenQuote from "./FinalScreenQuote.vue";

export default {
  store,
  props: [
    "wizardTitle",
    "wizardDescription",
    "infoText",
    "affiliate",
    "windowWidth",
    "windowHeight",
  ],
  components: {
    SystemMessage,
    UserMessage,
    ChatResponses,
    SummaryChat,
    FinalScreenChat,
    SummarySection,
    FinalScreenQuote,
  },
  data() {
    return {
      stage: 0,
      messages: [],
      responses: [],
      showLoader: false,
      showSummaryChat: false,
      showSummaryForm: false,
      showFinalMessage: false,
      showFinalQuotePage: false,
      finishedCalculating: false,
      startQuestions: false,
      formComplete: false,
      showOtherUnderwriters: false,
      showSummarySidebar: false,
      lastMessage: 0,
      user_responses: [],
      underwriters: [],
      questions: [],
      questionsSelections: [],
      fields: {
        // creating new fields will require the initialisation and also match the chat message key
        email: "",
        phone: "",
        occupation: "",
        occupation_id: "",
        underwriter_id: null,
        affiliate_id: null,
        chat_type: null,
        endorsements: [],
        postcode_of_risk: "",
        current_annual_revenue: "",
        email_quote_btn_clicked: false,
        head_count: "",
        percentage_of_insured_turnover_from_premises: "",
        percentage_of_insured_turnover_from_by_sub_contractors: "",
        period_of_cover: "12",
        limits_required: appConfigs.defaultAmountOption,
        deductible: "1000",
        amount_options: appConfigs.amountOptions,
        deductible_options: appConfigs.deductibleOptions.def,
        referral: "",
        agreed_to_declaration: null,
        affiliate_id: null,
        id: null,
        business_name: "",
        name: "",
        dob: "",
        gender: "",
        accident_cover_individual: null,
        accident_cover_id: null,
      },
      existingPendingOrderId: null,
      form_data: [],
      form: {
        // these are required for the endorsements and final calculations
        protecsure: {
          limits_required: appConfigs.defaultAmountOption,
          period_of_cover: 12,
          deductible: "",
        },
        brooklyn: {
          limits_required: appConfigs.defaultAmountOption,
          period_of_cover: 12, // constant
          deductible: 1000, // constant
        },
        ensurance: {
          limits_required: appConfigs.defaultAmountOption,
          period_of_cover: 12, // constant
          deductible: 500, // constant
        },
      },
    };
  },
  watch: {
    user_responses: function (val) {
      // Watching for any new user response
      this.userResponded();
    },
    messages: function (val) {
      var $this = this;
      // This is to scroll to the last message everytime it updates
      setTimeout(function () {
        $this.scrollToBottom();
      }, 500);
    },
    showLoader: function (val) {
      this.scrollToBottom();
    },
    hasWrongAnswer(quoteRejected) {
      this.$store.commit("setQuoteRejected", { quoteRejected });
    },
  },
  mounted() {
    this.fields.affiliate_id = this.affiliate;
    this.initChatbot(); 
  },

  computed: {
    // Retrieving the old pending order id
    pendingOrderId() {
      if (typeof Cookies.get("pendingOrderId") != "undefined") {
        return Cookies.get("pendingOrderId");
      }
      return false;
    },
    hasWrongAnswer() {
      return this.updateErrors().length > 0;
    },
    // Chat Avatar
    chatImageUrl() {
      if (this.fields.chat_type === "male") {
        return appConfigs.apiDomain + "images/male-cropped.jpg";
      } else {
        return appConfigs.apiDomain + "images/female-cropped.jpg";
      }
    },
    chatImageGifUrl() {
      return appConfigs.apiDomain + "images/chat-loader.svg";
    },

    ...mapState({
      configs: (state) => state.configs,
      step: (state) => state.step,
      prevStep: (state) => state.prevStep,
      quoteRejected: (state) => state.quoteRejected,
      summaryData: (state) => state.summaryData,
      calculating: (state) => state.calculating,
      accidentCover: (state) => state.accidentCover,
      showEmailBlock: (state) => state.showEmailBlock,
      customerEmail: (state) => state.customerEmail,
      agreedToTerms: (state) => state.agreedToTerms,
      existingPendingOrder: (state) => state.existingPendingOrder,
      stateByPostcode: (state) => state.stateByPostcode,
      agreedToDeclaration: (state) => state.agreedToDeclaration,
      errors: (state) => state.errors,
      pendingOrder: (state) => state.pendingOrder,
      showScreenLoader: (state) => state.showScreenLoader,
      unavailableOccupations: (state) => state.unavailableOccupations,
    }),
    // This is to adjust the total based on the efund rates and accident covers
    adjustedTotal() {
      if (isEmpty(this.summaryData)) {
        return 0;
      }

      let total = this.summaryData.totalPrice || 0;

      if (this.accidentCover) {
        total += parseFloat(this.accidentCover.price);
      }
      return (total * this.eFundInterestRate).toFixed(2);
    },
    // Calculates the monthly payment period
    monthlyPayments() {
      if (
        isEmpty(this.pendingOrder) ||
        this.pendingOrder.period_of_cover != 12
      ) {
        return 0;
      }
      let monthlyPayments = (this.adjustedTotal / 10).toFixed(2);
      return monthlyPayments;
    },
    underwriterId() {
      const randInt = Math.random().toString(36).substr(2, 10);
      return `quote_${randInt}`;
    },
    endorsements() {
      return (this.pendingOrder && this.pendingOrder.endorsements) || [];
    },
    underwriter() {
      return (this.pendingOrder && this.pendingOrder.underwriter) || [];
    },
    showUnavailableOccupation() {
      if (
        includes(this.unavailableOccupations, this.pendingOrder.occupation_id)
      ) {
        return false;
      } else {
        return true;
      }
    },
    isUnavailableOccupation() {
      if (
        includes(this.unavailableOccupations, this.pendingOrder.occupation_id)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    this.checkAndLoadPendingOrder();

    // let vm = this;
    // not the best solution, but due to some unknow issue,
    // if the vm.checkAndLoadPendingOrder() was called
    // directly, sometimes vue fields data was initalized , sometimes not
    // setTimeout(function () {
    // }, 1000);
  },

  methods: {
    ...mapActions({
      scrollToTop: "scrollToTop",
      loadPendingOrder: "loadPendingOrder",
      loadUnderwriters: "loadUnderwriters",
      loadQuestions: "loadQuestions",
      calculate: "calculate",
    }),
    ...mapMutations({
      toggleShowEmailBlock: "toggleShowEmailBlock",
      setAgreedToTerms: "setAgreedToTerms",
      updateExistingPendingOrderId: "updateExistingPendingOrderId",

      updateSelectedOccupation: "updateSelectedOccupation",
      setAgreedToDeclaration: "setAgreedToDeclaration",
      updateStateByPostcode: "updateStateByPostcode",
      // updateAccidentCover: "updateAccidentCover",
      // @deprecated - Accident Cover options have been disabled as per client request 
    }),
    // Required for the summary
    getUnderwriters() {
      const formData = Object.keys(this.form).reduce(
        (out, item) => ({
          ...out,
          [item]: {
            ...this.fields,
            ...this.form[item],
          },
        }),
        {}
      );

      return this.loadUnderwriters(formData);
    },

    updateMessage(message, index) {
      this.messages[index] = message;
    },

    checkAndLoadPendingOrder() {
      let orderId = null;
      if (typeof Cookies.get("pendingOrderId") === "undefined") {
        const fields = Object.keys(this.fields);
        orderId = this.pendingOrder?.id;
      } else {
        orderId = Cookies.get("pendingOrderId");
      }

      if (orderId == undefined || orderId == null) {
        return;
      }

      this.$store.commit("setScreenLoader", { showScreenLoader: true });

      this.loadPendingOrder({ orderId })
        .then((data) => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });

          if (!this.prevStep) {
            this.$store.commit("setStep", { step: data.step });
          }
        })
        .catch(() => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
        });
    },
    // To init the chat bot
    // Will randomise the chat gender
    // Also will create the inital system message
    async initChatbot() {
      const val = Math.floor(Math.random() * (50 - 10)) + 10;
      if (val % 2 === 1) {
        this.fields.chat_type = "male";
      } else {
        this.fields.chat_type = "female";
      }
      var domain = this.apiDomain();

      var $this = this;
      await axios
        .post(domain + "chatbot/init", {
          chat_type: $this.fields.chat_type,
        })
        .then(function (response) {
          var data = response.data;

          data.forEach((item) => {
            $this.messages.push({
              type: "system",
              content: item.message,
            });
            $this.lastMessage = item.id;
            $this.showLoader = false;
          });
          setTimeout(function () {
            $this.responses.push(data[data.length - 1]);
          }, 100);
        })
        .catch(function (error) {
          console.log("Error: " + error);
        });
    },
    scrollTo(value) {
      if (this.$refs[value] !== undefined) {
        this.$refs[value][0].$el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    },

    // Checking for the question answers,
    // This is to format the answers to system required type
    // Also to populate the last terms message
    questionAnswered(value) {
      if (value !== undefined && value !== null) {
        var $this = this;
        var qIndex = Number.parseInt(value.index);
        if (this.questionsSelections.length > qIndex + 1) {
          var question = this.questionsSelections[qIndex + 1];

          $this.fields[value.key] = value.data == "No" ? 0 : 1;

          this.messages.push({
            type: "user",
            content: value,
          });

          // check on the default answer
          if (value.data !== value.is_default) {
            $this.messages.push({
              content:
                "We will need to review this before the cover can be confirmed.",
              type: "system",
              questions: { data: { alert: true } },
            });
          }

          setTimeout(function () {
            $this.messages.push({
              content: question.message,
              type: "system",
              questions: question,
            });
          }, 50);

          this.responses = [];
          setTimeout(function () {
            $this.showLoader = false;
            $this.responses.push(question);
          }, 200);
        } else {
          this.messages.push({
            type: "user",
            content: value,
          });
          this.termsAndConditions();
          // populate the terms and conditions
        }
      }
    },
    // Terms messahe, here the last message is 33.
    // Change the last message if there are new or changed chat script
    termsAndConditions() {
      var $this = this;
      var url = this.apiDomain() + "chatbot/responses";
      $this.lastMessage = 31;
      axios
        .post(url, {
          stage: 4,
          user_response: "Completed Terms",
          last_message: $this.lastMessage,
          fields: $this.fields,
        })
        .then(function (response) {
          var data = response.data;

          // for all chat messages and responses
          if (data.length) {
            data.forEach((item) => {
              setTimeout(function () {
                if (data.length) {
                  $this.messages.push({
                    type: "system",
                    content: item.message,
                    questions: data[data.length - 1], // appends the question to the message
                  });
                  $this.lastMessage = item.id;
                }
              }, 50);
            });
          }

          $this.responses = [];
          $this.showLoader = false;
          // send message with a delay
          setTimeout(function () {
            if (data.length) {
              $this.responses.push(data[data.length - 1]);
            }
          }, 200);
        })
        .catch(function (error) {
          console.log("Error: " + error);
        });
    },
    // This function checks the email your quote or start cover options
    coverSelection(value) {
      if (value !== undefined && value !== null) {
        this.messages.push({
          type: "user",
          content: value,
        });
        // overriding email your quote selection
        if (value.data && value.data === "Email Your Quote") {
          this.fields.email_quote_btn_clicked = true;
          this.stage3();
          var getLastMessages = this.messages.filter((message) => {
            return message.type == "system";
          });
          this.messages.push({
            type: "system",
            content: "Your quote has been sent to " + this.fields.email,
            questions: [],
          });
        } else if (value.data && value.data === "Start Cover") {
          this.responses = [];
          this.user_responses = value;

          var lowestUnderwriter = this.pendingOrder.underwriter_id;
          // no underwriter value detected, assign the lowest underwriter to it
          if (lowestUnderwriter === "" && lowestUnderwriter == null) {
            this.fields.underwriter_id =
              this.pendingOrder.lowest_underwriter_id;
          }
          this.calculate(this.fields);
        }
      }
    },
    responseSelected(value) {
      if (value !== undefined && value !== null) {
        this.messages.push({
          type: "user",
          content: value,
        });
        this.user_responses = value;
        this.responses = [];
      } else {
        this.messages.push({
          type: "user",
          content: value.data,
          label: value.label,
          key: value.key,
        });
        this.user_responses = value.data;
        this.responses = [];
      }
    },
    // Override functions to switch the stage and send the backend the request
    // This is required for the quote form if they switch
    async stageCompleted(stage) {
      if (stage === 1) {
        await this.calculatePrice();
        await this.stage1();
        this.stage = 2; // update state stage value
      } else if (stage === 2) {
        // showing the loader chat bubble
        this.showLoader = true;
        const orderId = this.pendingOrder.id;
        await this.loadPendingOrder({ orderId });

        await this.calculatePrice();
        await this.stage2();
        this.stage = 3;

        await this.calculatePrice();
        await this.stage3();
        this.stage = 4; // update stage, required for questions
        await this.quoteQuestions();
      } else if (stage === 4) {
        // showing the loader chat bubble
        this.showLoader = true;
        const orderId = this.pendingOrder.id;
        await this.loadPendingOrder({ orderId });

        await this.calculatePrice();
        await this.stage4();
        this.stage = 5; // update stage, required for questions
        this.$store.commit("setCalculating", { calculating: false });
        this.showFinalQuotePage = true;
        this.showSummarySidebar = false;
        this.messages = [];
      }
    },

    async setupAccidentCover() {
      var cover = {
        id: this.fields.accident_cover_id,
        insuredIndividual: this.fields.accident_cover_individual,
      };

      // @deprecated - Accident Cover options have been disabled as per client request 
      // await this.updateAccidentCover({ cover });
    },
    // stage 1 validation request
    async stage1() {
      // Once email has been provided and price calculated, create a pending order with the customer
      var $this = this;
      await this.convertToFields();

      if (this.finishedCalculating) {
        axios
          .post(
            appConfigs.validateUrl,
            {
              ...this.fields,
              ...this.summaryData,
              step: 1,
              chat_type: this.fields.chat_type,
              existingPendingOrderId: this.existingPendingOrderId,
            },
            { timeout: 3000 }
          )
          .then((response) => {
            const pendingOrder = get(
              response,
              "data.pendingOrder",
              this.pendingOrder
            );
            Cookies.set("pendingOrderId", pendingOrder.id);
            $this.existingPendingOrderId = pendingOrder.id;
            $this.updateExistingPendingOrderId({
              existingPendingOrder: $this.existingPendingOrderId,
            });
            $this.$store.commit("setPendingOrder", { pendingOrder });
          })
          .then(() => {
            if (this.pendingOrder.in_referral || this.isUnavailableOccupation) {
              $this.messages.push({
                type: "system",
                content:
                  "We need to review your answers before providing a quote binding your cover with the underwriter.<br>I will pass this to our office. Our staff will be in touch with you shortly.",
                questions: [],
              });
              $this.messages.push({
                type: "system",
                content: "Thank you for using our Online Quote System.",
                questions: [],
              });
              Cookies.remove("pendingOrderId");
              $this.$store.commit("resetState");
              this.showFinalQuotePage = false;
              this.showSummarySidebar = false;
              this.stage = 1;
              this.responses = [];
            }
          })
          .catch((error) => {
            // alert("There was an error creating a pending order", error);
            this.$store.commit("setCalculating", { calculating: false });
            if (error.response?.data.rejectQuote) {
              this.$store.commit("setQuoteRejected", { quoteRejected: true });
              swal({
                icon: "warning",
                title: "Online Quote Unavailable",
                text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                      We can still help you get a quote in 99% of circumstances.
                      We will just require additional information.
                      We may need to talk to a specialist insurer.`,
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: null,
                    visible: true,
                    closeModal: true,
                  },
                  confirm: {
                    text: "Get A Customised Quote",
                    value: true,
                    closeModal: true,
                  },
                },
              }).then((value) => {
                if (value) {
                  window.location.href = this.configs.get_customised_quote_url;
                } else {
                  this.switchToForm();
                }
              });
            } else {
              swal({
              icon: "warning",
              title: "Online Quote Unavailable",
              text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                      We can still help you get a quote in 99% of circumstances.
                      We will just require additional information.
                      We may need to talk to a specialist insurer.`,
              buttons: {
                cancel: {
                  text: "Cancel",
                  value: null,
                  visible: true,
                  closeModal: true,
                },
                confirm: {
                  text: "Get A Customised Quote",
                  value: true,
                  closeModal: true,
                },
              },
            }).then((value) => {
              if (value) {
                window.location.href = this.configs.get_customised_quote_url;
              } else {
                this.switchToForm();
              }
            });
            }
            this.$store.commit("setSummaryData", { summaryData: false });
          });
      }
    },
    // stage 2 validation request
    async stage2() {
      var $this = this;
      await this.convertToFields();

      if (this.finishedCalculating) {
        this.fields.id = this.pendingOrder.id;

        axios
          .post(
            appConfigs.validateUrl,
            {
              ...this.fields,
              ...this.summaryData,
              step: 2,
            },
            { timeout: 3000 }
          )
          .then((response) => {
            const pendingOrder = get(
              response,
              "data.pendingOrder",
              this.pendingOrder
            );
            Cookies.set("pendingOrderId", pendingOrder.id);
            $this.existingPendingOrderId = pendingOrder.id;
            $this.updateExistingPendingOrderId({
              existingPendingOrder: this.existingPendingOrderId,
            });
            $this.$store.commit("setPendingOrder", { pendingOrder });
          })
          .catch((error) => {
            // alert("There was an error creating a pending order", error);
            this.$store.commit("setCalculating", { calculating: false });
            if (error.response?.data.rejectQuote) {
              this.$store.commit("setQuoteRejected", { quoteRejected: true });
              swal({
                icon: "warning",
                title: "Online Quote Unavailable",
                text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                            We can still help you get a quote in 99% of circumstances.
                            We will just require additional information.
                            We may need to talk to a specialist insurer.`,
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: null,
                    visible: true,
                    closeModal: true,
                  },
                  confirm: {
                    text: "Get A Customised Quote",
                    value: true,
                    closeModal: true,
                  },
                },
              }).then((value) => {
                if (value) {
                  window.location.href = this.configs.get_customised_quote_url;
                } else {
                  this.switchToForm();
                }
              });
            } else {
              swal({
                icon: "warning",
                title: "Online Quote Unavailable",
                text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                        We can still help you get a quote in 99% of circumstances.
                        We will just require additional information.
                        We may need to talk to a specialist insurer.`,
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: null,
                    visible: true,
                    closeModal: true,
                  },
                  confirm: {
                    text: "Get A Customised Quote",
                    value: true,
                    closeModal: true,
                  },
                },
              }).then((value) => {
                if (value) {
                  window.location.href = this.configs.get_customised_quote_url;
                } else {
                  this.switchToForm();
                }
              });
            }
            this.$store.commit("setSummaryData", { summaryData: false });
          });
      }
    },
    // Default calculations, used the old code
    calculateUnderwriters(underwriters = this.underwriters, filter = stubTrue) {
      this.fields.id = this.pendingOrder.id;

      return Promise.all([
        underwriters,
        ...underwriters.filter(filter).map((underwriter) =>
          this.calculate({
            ...this.fields,
            ...this.form[underwriter.prefix],
            underwriter_id: underwriter.id,
          })
        ),
      ])
        .then(([underwriters, ...data]) => {
          const summary = data.reduce(
            (out, item) => {
              out[item.underwriterId] = item;
              return out;
            },
            this.underwriters.reduce((out, item) => {
              out[item.id] = item.summary;
              return out;
            }, {})
          );

          this.underwriters = underwriters.map((item) => ({
            ...item,
            summary: summary[item.id],
          }));
        })
        .catch((error) => {
          this.underwriters = underwriters.map((item) => {
            return filter(item)
              ? {
                  ...item,
                  summary: undefined,
                }
              : item;
          });

          return Promise.reject(error);
        });
    },
    async getAndCalculateUnderwriters() {
      await this.getUnderwriters()
        .then((underwriters) =>
          this.calculateUnderwriters(
            underwriters,
            (underwriter) =>
              !underwriter.disabled &&
              (!currentUnderwriter || underwriter.prefix === currentUnderwriter)
          )
        )
        .then(() => {
          this.$store.commit("setCalculating", { calculating: false });
          this.$store.commit("clearError");
          this.finishedCalculating = true;
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.$store.commit("setScreenLoaderText", { screenLoaderText: " " });
        })
        .catch((error) => {
          this.$store.commit("setCalculating", { calculating: false });
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.$store.commit("setScreenLoaderText", { screenLoaderText: " " });
        });
    },
    // Stage 3 validation request
    async stage3() {
      var $this = this;
      await this.convertToFields();

      if (this.finishedCalculating) {
        this.fields.id = this.pendingOrder.id;

        var lowestUnderwriter = this.pendingOrder.underwriter_id;
        // no underwriter value detected, assign the lowest underwriter to it
        if (lowestUnderwriter === "" && lowestUnderwriter == null) {
          this.fields.underwriter_id = this.pendingOrder.lowest_underwriter_id;
        }

        // add accident cover
        await this.setupAccidentCover();

        // requires the underwriter_id, otherwise will throw validate errors
        await this.getAndCalculateUnderwriters();

        const underwriter =
          this.underwriters.filter(
            (item) => item.id == this.fields.underwriter_id
          )[0] || {};
        const summaryData = underwriter.summary;

        axios
          .post(appConfigs.validateUrl, {
            ...this.fields,
            ...this.summaryData,
            ...this.form[underwriter.prefix],
            step: 3,
            accident_cover: this.accidentCover ? this.accidentCover : null,
            endorsements:
              summaryData && summaryData.endorsements
                ? summaryData.endorsements
                : [],
          })
          .then((response) => {
            const pendingOrder = get(
              response,
              "data.pendingOrder",
              this.pendingOrder
            );
            Cookies.set("pendingOrderId", pendingOrder.id);
            this.existingPendingOrderId = pendingOrder.id;
            this.updateExistingPendingOrderId({
              existingPendingOrder: this.existingPendingOrderId,
            });
            this.$store.commit("setPendingOrder", { pendingOrder });
          })
          .catch((error) => {
            swal({
              icon: "warning",
              title: "Online Quote Unavailable",
              text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                      We can still help you get a quote in 99% of circumstances.
                      We will just require additional information.
                      We may need to talk to a specialist insurer.`,
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: null,
                    visible: true,
                    closeModal: true,
                  },
                  confirm: {
                    text: "Get A Customised Quote",
                    value: true,
                    closeModal: true,
                  },
                },
              }).then((value) => {
                if (value) {
                  window.location.href = this.configs.get_customised_quote_url;
                } else {
                  this.switchToForm();
                }
              });
          });
      }
    },
    // stage 4 validation request
    async stage4() {
      var $this = this;
      $this.showLoader = true;
      $this.calculatePrice();

      await axios
        .post(appConfigs.validateUrl, {
          ...this.fields,
          in_referral: this.hasWrongAnswer,
          step: 4,
          id: this.pendingOrder.id,
        })
        .then((response) => {
          const pendingOrder = get(
            response,
            "data.data.pendingOrder",
            $this.pendingOrder
          );
          $this.$store.commit("setPendingOrder", { pendingOrder });
          if (pendingOrder.in_referral) {
            Cookies.remove("pendingOrderId");
            $this.$store.commit("resetState");
            $this.messages.push({
              type: "system",
              content:
                "We need to review your answers before providing a quote binding your cover with the underwriter.<br>I will pass this to our office. Our staff will be in touch with you shortly.",
              questions: [],
            });
            $this.messages.push({
              type: "system",
              content: "Thank you for using our Online Quote System.",
              questions: [],
            });
          } else {
            $this.messages.push({
              type: "system",
              content:
                "Looks like, everything checks out. I will redirect you to the payment page to confirm your Quote.",
              questions: [],
            });
          }

          $this.showLoader = false;
        })
        .catch((error) => {
          let errorMessage = generateErrorMessage(error);
          $this.$store.commit("setError", { error: errorMessage });
          $this.showLoader = false;
          swal({
              icon: "warning",
              title: "Online Quote Unavailable",
              text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                      We can still help you get a quote in 99% of circumstances.
                      We will just require additional information.
                      We may need to talk to a specialist insurer.`,
              buttons: {
                cancel: {
                  text: "Cancel",
                  value: null,
                  visible: true,
                  closeModal: true,
                },
                confirm: {
                  text: "Get A Customised Quote",
                  value: true,
                  closeModal: true,
                },
              },
            }).then((value) => {
              if (value) {
                window.location.href = this.configs.get_customised_quote_url;
              } else {
                this.switchToForm();
              }
            });
        });
    },
    // used the old calculate price function
    calculatePrice: async function () {
      this.$store.commit("setCalculating", { calculating: true });
      await this.calculate(this.fields)
        .then((data) => {
          this.$store.commit("setSummaryData", { summaryData: data });

          this.$store.commit("clearError");
          if (this.pendingOrderId) {
            this.$store.commit("setCalculating", { calculating: false });
          }
          this.finishedCalculating = true;
          this.formLoading = false;
        })
        .catch(async (error) => {
          this.$store.commit("setCalculating", { calculating: false });
          if (error.response?.data.rejectQuote) {
            this.$store.commit("setQuoteRejected", { quoteRejected: true });
            if (this.stage === 1) {
              await this.stage1();
            }
            swal({
              icon: "warning",
              title: "Online Quote Unavailable",
              text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                      We can still help you get a quote in 99% of circumstances.
                      We will just require additional information.
                      We may need to talk to a specialist insurer.`,
              buttons: {
                cancel: {
                  text: "Cancel",
                  value: null,
                  visible: true,
                  closeModal: true,
                },
                confirm: {
                  text: "Get A Customised Quote",
                  value: true,
                  closeModal: true,
                },
              },
            }).then((value) => {
              if (value) {
                window.location.href = this.configs.get_customised_quote_url;
              } else {
                this.switchToForm();
              }
            });
          } else {
            swal({
              icon: "warning",
              title: "Online Quote Unavailable",
              text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                      We can still help you get a quote in 99% of circumstances.
                      We will just require additional information.
                      We may need to talk to a specialist insurer.`,
              buttons: {
                cancel: {
                  text: "Cancel",
                  value: null,
                  visible: true,
                  closeModal: true,
                },
                confirm: {
                  text: "Get A Customised Quote",
                  value: true,
                  closeModal: true,
                },
              },
            }).then((value) => {
              if (value) {
                window.location.href = this.configs.get_customised_quote_url;
              } else {
                this.switchToForm();
              }
            });
          }
          this.$store.commit("setSummaryData", { summaryData: false });
          const errorMessage = generateErrorMessage(error);
          this.$store.commit("setError", { error: errorMessage });
        });
    },
    // Converting the formats of messages
    convertToFields() {
      if (this.messages !== undefined) {
        this.messages.map((message) => {
          if (
            message.type == "user" &&
            message.content !== null &&
            message.content.key !== undefined &&
            message.content.key !== null
          ) {
            var fieldValue = message.content.data;

            // if its a selection, add the selected results id
            if (fieldValue.id !== undefined) {
              fieldValue = fieldValue.id;
            }

            this.fields[message.content.key] = fieldValue ?? "";
          }
        });

        if (this.fields.agreed_to_declaration === null) {
          this.fields.agreed_to_declaration = false;
        }

        if (this.fields.email) {
          this.fields.email =
            typeof this.fields.email === "string"
              ? this.fields.email.toLowerCase()
              : this.fields.email;
        }

        // value changes
        this.fields.occupation = this.fields.occupation_id;
        if (this.fields.occupation.id !== undefined) {
          this.fields.occupation_id = this.fields.occupation.id;
        }

        if (this.fields.limits_required !== null) {
          this.fields.limits_required = this.fields.limits_required.replace(
            " Million",
            "000000"
          );
        }

        if (this.fields.deductible !== null) {
          this.fields.deductible = this.fields.deductible.replace("$", "");
        }

        if (this.fields.agreed_to_declaration !== null) {
          this.fields.agreed_to_declaration =
            this.fields.agreed_to_declaration == "Yes" ? 1 : 0;
        }
      }
    },
    // This is the function that sends the response and organises the flow of the chat
    // Backend will send the response, if its a stage completion or final will be decided here
    async userResponded() {
      var stage = this.stage;
      var messages = this.messages;
      var responses = this.responses;
      var $this = this;

      // Loader
      $this.showLoader = true;
      $this.convertToFields();
      await this.preChecks();

      var domain = this.apiDomain();
      // console.log('User Responded.');
      var url = domain + "chatbot/responses";
      await axios
        .post(
          url,
          {
            stage: stage,
            user_response: $this.user_responses,
            last_message: $this.lastMessage,
            fields: $this.fields,
            occupation_id: $this.lastMessage > 25 ? $this.fields?.occupation_id : null,
          },
          { timeout: 5000 }
        )
        .then(function (response) {
          var data = response.data;
          $this.responses = [];
          // checking whether the stage is complete
          // retrieving the last message from user
          var userMessages = $this.messages.filter((item) => {
            return item.type === "user";
          });
          var lastUserMessage =
            userMessages !== null && userMessages.length > 1
              ? userMessages[userMessages.length - 1]
              : null;

          // sending requests to complete the stage
          var stageCompleted =
            lastUserMessage !== null &&
            lastUserMessage.question !== undefined &&
            lastUserMessage.question.data !== undefined &&
            lastUserMessage.question.data.stage_complete !== undefined &&
            lastUserMessage.question.data.stage_complete == true
              ? true
              : false;
          if (stageCompleted) {
            // sending request to create the pending order
            if (lastUserMessage.question.data.stage !== null) {
              if (lastUserMessage.question.data.stage == 1) {
                // breaking the current flow in order to go step by step for the questsions and payments
                $this.stageCompleted(lastUserMessage.question.data.stage);
                $this.startFinalStages(data);
                return;
              }
            }
          }

          // for all chat messages and responses
          if (data.length) {
            if (data[0].message == "Summary Chat") {
              $this.showSummaryChat = true;
            } else {
              data.forEach((item, index) => {
                setTimeout(function () {
                  if (data.length) {
                    $this.messages.push({
                      type: "system",
                      content: item.message,
                      questions:
                        data.length - 1 == index ? data[data.length - 1] : null, // appends the question to the last message
                    });
                    $this.lastMessage = item.id;

                    // check if its a quote chat or lead chat
                    if (data[data.length - 1].id >= 16) {
                      $this.showSummarySidebar = true;
                      $this.stage = 1;
                    } else {
                      $this.showSummarySidebar = false;
                    }
                  }
                }, 200);
              });
            }
            $this.responses = [];
          }

          $this.showLoader = false;

          // stage 2 and stage 3 validations
          if (stageCompleted) {
            // sending request to create the pending order
            if (lastUserMessage.question.data.stage !== null) {
              $this.stageCompleted(lastUserMessage.question.data.stage);
            }
          }

          // send message with a delay
          setTimeout(function () {
            if (data.length) {
              $this.responses.push(data[data.length - 1]);
            }
          }, 250);
        })
        .catch(function (error) {
          console.log("Error: " + error);
        });
    },
    // send to zoho used from the old code
    async sendToZoho() {
      var messages = this.messages;
      var domain = this.apiDomain();
      var url = domain + "chatbot/send";
      var $this = this;
      await axios
        .post(url, {
          messages: messages,
          chat_type: $this.fields.chat_type,
        })
        .then(function (response) {
          $this.showLoader = false;
          $this.$refs.chatLoader.scrollIntoView();
        })
        .catch(function (error) {
          console.log("Error: " + error);
        });
    },
    showDetails() {
      this.showSummaryForm = !this.showSummaryForm;
    },
    // switch quote type function
    switchToForm() {
      // Check response no to redirect to form

      this.$store.commit("setScreenLoader", { showScreenLoader: true });
      this.convertToFields();
      var switchStep = this.step > 0 ? 1 : 0;
      axios
        .post(appConfigs.validateUrl, {
          ...this.fields,
          ...this.summaryData,
          abn: this.abn,
          step: switchStep,
          referral: this.fields.referral, // ???
          id: this.pendingOrderId,
          existingPendingOrderId: this.existingPendingOrderId,
        })
        .then((response) => {
          const pendingOrder = get(
            response,
            "data.pendingOrder",
            this.pendingOrder
          );
          Cookies.set("pendingOrderId", pendingOrder.id);
          Cookies.set("setStep", switchStep);
          Cookies.set("chatType", this.fields.chat_type);
          this.$store.commit("incrementStep");
          this.$store.commit("clearError");
          this.$store.commit("setScreenLoader", {
            showScreenLoader: false,
          });
          this.$store.commit("setPendingOrder", { pendingOrder });
          this.scrollToTop();
        })
        .catch((error) => {
          const errorMessage = generateErrorMessage(error);
          this.$store.commit("setError", { error: errorMessage });
          this.$store.commit("setScreenLoader", {
            showScreenLoader: false,
          });
        });
    },
    restartChat() {
      this.stage = 0;
      this.messages = [];
      this.responses = [];
      this.showLoader = false;
      this.showSummaryChat = false;
      this.showSummaryForm = false;
      this.showFinalMessage = false;
      this.showFinalQuotePage = false;
      this.finishedCalculating = false;
      this.startQuestions = false;
      this.formComplete = false;
      this.showOtherUnderwriters = false;
      this.showSummarySidebar = false;
      this.lastMessage = 0;
      this.user_responses = [];
      this.underwriters = [];
      this.questions = [];
      this.questionsSelections = [];
      this.fields = {
        email: "",
        phone: "",
        occupation: "",
        occupation_id: "",
        underwriter_id: null,
        affiliate_id: null,
        chat_type: null,
        postcode_of_risk: "",
        current_annual_revenue: "",
        email_quote_btn_clicked: false,
        head_count: "",
        percentage_of_insured_turnover_from_premises: "",
        percentage_of_insured_turnover_from_by_sub_contractors: "",
        period_of_cover: "12",
        limits_required: appConfigs.defaultAmountOption,
        deductible: "1000",
        amount_options: appConfigs.amountOptions,
        deductible_options: appConfigs.deductibleOptions.def,
        referral: "",
        agreed_to_declaration: null,
        affiliate_id: null,
        id: null,
        business_name: "",
        name: "",
        dob: "",
        gender: "",
        accident_cover_individual: "",
        accident_cover_id: "",
      };
      this.existingPendingOrderId = null;

      // remove all state cookies and restart chatbot
      Cookies.remove("pendingOrderId");
      this.$store.commit("resetState");
      this.initChatbot();
    },
    apiDomain() {
      return appConfigs.apiDomain;
    },
    scrollToBottom() {
      //   let scrollHeight = Math.max(
      //   document.body.scrollHeight, document.getElementById('chatDiv').scrollHeight,
      //   document.body.offsetHeight, document.getElementById('chatDiv').offsetHeight,
      //   document.body.clientHeight, document.getElementById('chatDiv').clientHeight
      // );

      //   document.getElementById('chatDiv').scrollTop = scrollHeight;
      this.$refs.chatEndPoint.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    },

    async chatQueryCompleted(data) {
      this.messages = data;
      // Loader
      this.showLoader = true;
      this.$refs.chatLoader.scrollIntoView();
      await this.sendToZoho();
      this.showSummaryChat = false;
      this.showFinalMessage = true;
    },

    async preChecks() {
      // await ...
    },
    async startFinalStages(data) {
      var $this = this;
      this.calculate(this.fields);
      if (this.calculating) {
        data.forEach((item) => {
          $this.messages.push({
            type: "system",
            content: item.message,
            questions: data[data.length - 1], // appends the question to the message
          });
          $this.lastMessage = item.id;

          // check if its a quote chat or lead chat
          if (data[data.length - 1].id >= 16) {
            $this.showSummarySidebar = true;
            $this.stage = 1;
          } else {
            $this.showSummarySidebar = false;
          }
        });

        $this.showLoader = false;

        $this.responses = [];

        // send message with a delay
        setTimeout(function () {
          if (data.length) {
            $this.responses.push(data[data.length - 1]);
          }
        }, 300);
      }
    },

    updateErrors() {
      var filledAnswers = {};
      for (var key in this.questions) {
        var answers = this.questions[key].reduce((d, question) => {
          d[question.field_tag] = question.answer;
          return d;
        }, {});

        for (var k in answers) {
          filledAnswers[k] = answers[k];
        }
      }

      var errors = [];
      for (var field in filledAnswers) {
        var answeredValue =
          this.fields[field] === "No" || this.fields[field] == 0 ? 0 : 1;
        if (answeredValue != filledAnswers[field]) {
          errors.push(field);
        }
      }

      return errors;
    },
    // This is to show case or populate the questions

    quoteQuestions() {
      var $this = this;
      this.showLoader = true;
      const orderId = this.pendingOrder.id;
      this.loadPendingOrder({ orderId })
        .then((data) => {
          const fields = {
            ...this.fields,
            ...data,
          };

          return Promise.all([
            this.loadQuestions(fields),
            this.calculate(fields),
          ])
            .then(([questions, summaryData]) => {
              this.$store.commit("setSummaryData", { summaryData });
              this.updateStateByPostcode({
                stateByPostcode: summaryData.state,
              });
              this.questions = questions;

              const questionAnswers = data.questionAnswers;
              var questionsFields = {};
              for (var key in questions) {
                for (var index in questions[key]) {
                  questionsFields[questions[key][index].field_tag] = questions[
                    key
                  ][index].answer
                    ? questionAnswers.answer
                    : undefined;

                  // add questions to the selection array
                  // this will be used to iterate questions
                  this.questionsSelections.push({
                    answer_type: "selection_question",
                    data: {
                      subheading: "",
                      options: ["Yes", "No"],
                      default: questions[key][index].answer == 1 ? "Yes" : "No",
                      key: questions[key][index].field_tag,
                      label: "Question (" + (index + 1) + ")",
                      index: index,
                    },
                    id: questions[key][index].id,
                    message: questions[key][index].body,
                  });
                }
              }

              this.fields = {
                ...this.fields,
                ...questionsFields,
              };

              if (this.questionsSelections.length == 0) {
                // if no questions are there,
                // to show the terms and conditions
                this.termsAndConditions();
              } else {
                var question1 = this.questionsSelections[0];

                setTimeout(function () {
                  $this.messages.push({
                    content: question1.message,
                    type: "system",
                    questions: question1,
                  });
                }, 200);

                this.responses = [];

                setTimeout(function () {
                  $this.showLoader = false;
                  $this.responses.push(question1);
                }, 400);
              }
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang="scss">
.p-y-50 {
  padding-top: 50px;
  padding-bottom: 50px;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
@media screen and (max-width: 769px) {
  .wizard-header {
    padding: 0 !important;
  }
  .wizard-title {
    font-size: 1.25rem !important;
  }
  .wizard-container {
    padding-top: 5px !important;
  }
  .chat-area-parent {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .chat-area {
    /* height: 650px !important; */
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}
.error-message {
  padding-top: 20px;
}

.chat-list-area-parent {
  padding: 0;
}
.chat {
  padding: 1.5rem;
}
.message {
  padding: 0.25rem 1rem;
}
.avatar {
  border: 1px solid #dedede;
}
.message-box {
  border: 1px solid #dedede;
  background-color: #f1f0f0;
  padding: 10px;
  color: #000;
  margin-top: 3px;
  border-radius: 0px 15px 15px;
  width: fit-content;
  max-width: 60%;
  font-size: 16px;
  line-height: 26px;
}
.chat-area {
  background-color: #fff;
  height: 50vh;
  overflow-x: hidden;
  padding-top: 10px;
  overflow-y: auto;
  border-radius: 6px;
  padding-bottom: 20px;
  position: relative;
}
.chat-list-area {
  background-color: #f4f4f4;
  min-height: 80vh;
  margin-right: 20px;
  margin-left: 0px !important;
  height: auto;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
}

/* .wizard-card .tab-content {
  min-height: 75vh;
} */

#scrollPoint {
  margin-top: 10px;
}

@media screen and (max-width: 768px) {
  .message-box {
    max-width: 100%;
  }
}

.modal {
  background-color: rgba(222, 222, 222, 0.2);
  padding: 10px;
  border-radius: 0.25rem;
}
.modal.show {
  display: block !important;
}
.modal.hide {
  display: none !important;
}
.modal-header {
  width: 100% !important;
  display: flex !important;
  flex-wrap: wrap;
}
.modal-header .modal-title {
  margin-top: 0 !important;
}
.endorsement-info:hover {
  color: #009245 !important;
}
</style>
